import React from 'react';
import PageWrapper from '../components/PageWrapper';
import { useAuthEffects } from '../components/Auth';
import { Box, Divider, Grid2, ImageListItem, ImageList, useMediaQuery, ImageListItemBar, useTheme, IconButton } from '@mui/material';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';

const CategoriesView = () => {
	useAuthEffects();

	const theme = useTheme();
	const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));

	return <PageWrapper>
		<Grid2 container spacing={8}>
			<Grid2 size={12}>
				<Divider sx={{mt: 1}}/>
				<Box display='flex'>
					<ImageList cols={isSmUp ? 4 : 2} rowHeight={250}>
						{itemDataNew.map((item) => (
							<ImageListItem key={item.img}>
								<img
									srcSet={`${item.img}?w=248&fit=crop&auto=format&dpr=2 2x`}
									src={`${item.img}?w=248&fit=crop&auto=format`}
									alt={item.title}
									loading="lazy"
									style={{overflow:'hidden'}}
								/>
								<ImageListItemBar
									// sx={{backgroundColor: 'rgba(0,0,0,0.9)'}}
									title={item.title}
									// subtitle={item.author}
									actionIcon={
										<IconButton
											sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
											aria-label={`info about ${item.title}`}
										>
											<OpenInFullIcon />
										</IconButton>
									}
								/>
							</ImageListItem>
						))}
					</ImageList>
				</Box>
			</Grid2>
		</Grid2>
	</PageWrapper>;
};

export default CategoriesView;

const itemDataNew = [
	{
		'img': 'https://i.etsystatic.com/19738945/r/il/25331a/4320685919/il_fullxfull.4320685919_s008.jpg',
		'title': 'Shelves',
		'author': '@organizedliving'
	},
	{
		'img': 'https://i.pinimg.com/736x/52/29/18/5229180c852721216a4845bf80f097af.jpg',
		'title': 'Garden',
		'author': '@organizedliving'
	},
	{
		'img': 'https://rollerup.ca/wp-content/uploads/elementor/thumbs/Wooden-Outdoor-Privacy-Screens-ppzbcs89mpt3480vnmuzmgb71cl0dxsrth0lvp5rls.jpeg',
		'title': 'Patio',
		'author': '@organizedliving'
	},
	{
		'img': 'https://www.synchrony.com/syfbank/images/hero-bang-for-buck-home-improvment-projects-1140x570-article.png',
		'title': 'Paint',
		'author': '@organizedliving'
	},
	{
		'img': 'https://t3.ftcdn.net/jpg/00/95/01/92/360_F_95019254_aQEM0BqzFIAgXGSgQTmJ3PQtDABuY5Iy.jpg',
		'title': 'Other categories',
		'author': '@organizedliving'
	},
	// {
	// 	'img': 'https://hips.hearstapps.com/hmg-prod/images/diy-coffee-table-1555528219.jpg?crop=1xw:1xh;center,top&resize=980:*',
	// 	'title': 'New Furniture',
	// 	'author': '@organizedliving'
	// },
	// {
	// 	'img': 'https://media.angi.com/s3fs-public/woman-painting-house-exterior-110515212.jpeg?impolicy=leadImage',
	// 	'title': 'Exterior',
	// 	'author': '@organizedliving'
	// }
];  
  